
import type { PageViewUserType, PageViewPageType } from '~~/types/integrations/tagManager/TagManagerIntegration';
import { EVENT_PAGE_VIEW } from '~~/constants/googleTagManager';

export const buildPageViewTags = ({ page, user }: {
  page: PageViewPageType,
  user: PageViewUserType
}) => ({
  event: EVENT_PAGE_VIEW,
  page,
  user,
});
